export const DIGITAL = 'offer';
export const PHYSICAL = 'physical';
export const SERVICE = 'membership';
export const EVENT = 'event';



// WEBPACK FOOTER //
// ./src/common/config/ProductTypes.js